import 'v-tooltip/dist/v-tooltip.css'
import {  
  MethodsFastReport,
    MethodsStrGet,
    MethodsStrSingleGet,
    MethodsStrSabitGet,
    MethodsStrFilterGet,
    MethodsStrPost,
    MethodsStrPut,
    MethodsStrPutList,
    MethodsStrDelete, 
    MethodsActionsLogin,
    MethodsActionsAuth,
    GenericComputed ,
    MethodsActionsRefreshToken,
    MethodsTokenZamaniHesaplama, 
    MethodsResetPasswordLogin,
    MethodsUserUpdateLogin,
    MethodsActionsFileGet,
    } from "@/state/helpers";

    import moment from "moment"; 
const Sabit = {
    data() {
      return {   
      }
    },
    methods: {
    ...MethodsFastReport,
    ...MethodsStrGet,
    ...MethodsStrSingleGet,
    ...MethodsStrSabitGet,
    ...MethodsStrFilterGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrPutList,
    ...MethodsStrDelete, 
    ...MethodsActionsLogin,
    ...MethodsActionsAuth,
    ...GenericComputed,
    ...MethodsActionsRefreshToken,
    ...MethodsTokenZamaniHesaplama, 
    ...MethodsResetPasswordLogin,
    ...MethodsUserUpdateLogin,
    ...MethodsActionsFileGet,
                ChangePage(DefaultPage) {
                    if(DefaultPage){ 
                        this.Page.PageNumber = DefaultPage
                        this.Get(); 
                    }
                }
    },
    computed: {
      ...GenericComputed
    }, 
    watch:{ 
    },
    created(){   
        this.Get();    
    }, 
    mounted() { 
      setTimeout(() => {
        this.showModal = true;
      }, 1500);
    }, 
    filters: {
      formatDate(value) {
        if (value) {
          return moment(String(value)).format("YYYY-MM-DD");
        }
      },
      formatDateTable(value) {
        if (value) {
          return moment(String(value)).format("DD.MM.YYYY");
        }
      }, 
      formatDateTime(value) {
        if (value) {
          return moment(String(value)).format("DD.MM.YYYY HH:DD");
        }
      }, 
      formatNoktaToVirgul(value) {
        if (value) {
          return  value.split('.').join(',');
        }
      },

       BindeAyiraci(value) {
        if (value) {

          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        
        }
      }

    },
     
  }
 
  export default Sabit
